import React from 'react';
import PropTypes from "prop-types";

import AnswerOptions from './AnswerOptions';
import DnDDroppableItem from './DnDDroppableItem';

function DragAndDropPuzzle({component_data}) {
    function getDnDContainerStyle() {
        const bgImg = _.get(component_data, 'data.background_img');
        const width = _.get(component_data, 'config.width');
        const height = _.get(component_data, 'config.height');

        return {
            backgroundImage: `url(${bgImg})`,
            backgroundRepeat: 'no-repeat',
            width,
            height
        }
    }

    function renderLayout() {
        const answerLayout = _.get(component_data, 'data.answer_layout');
        const renderLayoutItems = answerLayout.map((item, key) => {
            switch (item.type) {
                case 'dnd':
                    return (
                        <DnDDroppableItem
                            key={key}
                            component_data={component_data}
                            item={item}
                        />
                    );
                case 'static':
                default:
                    return null;
            }
        });

        return (
            <div className="cc-dndpuzzle-layout">
                {renderLayoutItems}
            </div>
        );
    }

    return (
        <div className="challenge-component-dndpuzzle">
            <AnswerOptions
                component_data={component_data}
            />

            <div className="cc-dndpuzzle-scroll">
                <div
                    className="cc-dndpuzzle-bg"
                    style={getDnDContainerStyle()}
                >
                    {renderLayout()}
                </div>
            </div>
        </div>
    );
}

DragAndDropPuzzle.propTypes = {
    component_data: PropTypes.shape({
        data: PropTypes.shape({
            answer_layout: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string.isRequired,
                dnd_type: PropTypes.string,
                dnd_id: PropTypes.string,
                placeholder: PropTypes.string,
                content: PropTypes.shape({
                    html: PropTypes.string.isRequired,
                    text: PropTypes.string.isRequired
                })
            })).isRequired
        }).isRequired
    }).isRequired,
    question_id: PropTypes.number
}

export default DragAndDropPuzzle
